<template>
  <div id="page-homerequest" class="d-flex">
    <!--MainBarMenu /-->
    <div class="layout-content container-fluid">
      <!--HeadingUser/-->
      <div class="row">
        <div class="col-12 pt-1" align="left">
          <router-link :to="'/inforequest/'+this.$route.params.id+'/'+this.$route.params.cc">
            <b-button variant="light">
              &lt;&lt;&lt;--- Volver atras
            </b-button>
          </router-link>
        </div>        
      </div>
      <div class="page-request py-0">        
        <div class="container">
          <p class="title-3 mb-0 mt-0">FORMATO DE AUSENTISMO</p>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="cont-request-text d-flex flex-column justify-content-around mt-0 mt-md-0">          
                <!-- .cont-title -->
                <form                  
                  class="form-request mt-0 mb-5 mb-md-5 d-flex flex-column flex-md-row align-items-center">                    
                      <div role="tablist">
                        <b-card no-body class="mb-1" style="width: 470px !important;">                          
                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="button1" block v-b-toggle.accordion-1 variant="info">                              
                               Datos del trabajador
                              <span class="when-opened">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                              <span class="when-closed">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                            </b-button>
                          </b-card-header>
                          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Ciudad</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.city"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Fecha</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.date"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Nombre</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.name"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Vicepresidencia</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.vice_presidency"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">División</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.division"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Código SAP</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.sap"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Cedula:</p>
                                  </div>
                                  <div class="col-9">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.cc"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                              <!--/b-card-text-->
                            </b-card-body>
                          </b-collapse>
                        
                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="button1" block v-b-toggle.accordion-2 variant="info">
                              Tipo de permiso y/o licencia
                              <span class="when-opened">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                              <span class="when-closed">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                            </b-button>
                          </b-card-header>
                          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                              <b-card-text>
                                <div class="row">
                                  <div class="col-1">
                                    <input id="p-dia" 
                                      class="mycheck" 
                                      type="checkbox"                                       
                                      checked = true
                                      disabled = true
                                    >
                                  </div>
                                  <div class="col-5">
                                    <p class="p1">Licencia remunerada</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="p1">¿Cual?: Permiso Sindical</p>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>

                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="button1" block v-b-toggle.accordion-3 variant="info">
                              Información del permiso:
                              <span class="when-opened">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                              <span class="when-closed">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                            </b-button>
                          </b-card-header>
                          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                              <b-card-text>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Fecha inicio</p>
                                  </div>
                                  <div class="col-3">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.start_date"
                                      readonly = true
                                    >
                                  </div>
                                  <div class="col-3">
                                    <p class="p1">Hora inicio</p>
                                  </div>
                                  <div class="col-3">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.start_hour"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Fecha fin</p>
                                  </div>
                                  <div class="col-3">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.end_date"
                                      readonly = true
                                    >
                                  </div>
                                  <div class="col-3">
                                    <p class="p1">Hora fin</p>
                                  </div>
                                  <div class="col-3">
                                    <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.end_hour"
                                      readonly = true
                                    >
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12 mb-md-5">
                                    <textarea class="form-control" v-model="observaciones" placeholder="Observaciones (Registre aquí lo que usted o su jefe consideren adicional a la información ya suministrada)" rows="5"></textarea>
                                  </div>                            
                                </div>                          
                              </b-card-text>                  
                            </b-card-body>
                          </b-collapse>

                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="button1" block v-b-toggle.accordion-4 variant="info">
                              Anexos
                              <span class="when-opened">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                              <span class="when-closed">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                            </b-button>
                          </b-card-header>
                          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                              <b-card-text>
                                <div class="row">
                                  <div class="col-1">
                                    <input id="p-dia" 
                                      class="mycheck" 
                                      type="checkbox"                                       
                                      checked = true
                                      disabled = true
                                    >
                                  </div>
                                  <div class="col-4">
                                    <p class="p1">Otros</p>
                                  </div>
                                  <div class="col-7">
                                    <p class="p1">¿Cual?: Aprobación permiso sindical</p>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>

                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button class="button1" block v-b-toggle.accordion-5 variant="info">
                              Autorizaciones
                              <span class="when-opened">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-up.svg">
                              </span>
                              <span class="when-closed">                            
                                <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                              </span>
                            </b-button>
                          </b-card-header>
                          <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                              <b-card-text>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Nombre del Coordinador</p>
                                  </div>
                                  <div class="col-9">
                                    <p class="p2">
                                      <input type="text"                                    
                                      class="form-control"
                                      :value="this.ausentismo.boss"
                                      readonly = true
                                    >
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <p class="p1">Firma Coordinador</p>
                                  </div>
                                  <div class="col-9">
                                    <p class="p2">
                                      <input type="text"
                                    v-model="motivoPermiso"                                    
                                    class="form-control"
                                    required>                                     
                                    </p>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                        <div class="row">                          
                          <div class="col-12 pt-5" align="center">
                            <button 
                            type="submit" 
                            class="btn btn-block btn-darkblue-1"
                            v-on:click="saveObservation"
                            >
                              Guardar observacion
                            </button>
                          </div>                          
                        </div>
                        <div class="row">
                          <div class="col-12 pt-5" align="center">
                            <small v-show="error.flag" class="alert-danger">
                              <b align="center">{{ error.message }}</b>
                            </small>
                            <small v-show="success.flag" class="alert-heading">                            
                              <b-alert show variant="success">
                                <strong>{{ success.message }}</strong>
                              </b-alert>
                            </small>
                          </div>
                        </div>
                      </div>
                </form>          
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <FormatAbsentismo
              :ausentismo = "this.ausentismo"
              :observaciones = "this.observaciones"
              :sharp_id = "this.$route.params.cc"
              :id = "this.$route.params.id"
              >
              </FormatAbsentismo>
            </div>
          <!-- .col -->
          </div>
        <!-- .row -->
        </div>
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import FormatAbsentismo from "./formatAbsentismos.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Ausentismo",
  components: {
    FormatAbsentismo  
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      ausentismo: [],
      observaciones: '',
    };
  },
  beforeMount() {
    let data = [];

    data[0] = this.$route.params.id;
    data[1] = this.$route.params.cc;

    this.actGetAbsenteeism(data).then(() =>{
        this.ausentismo = this.absenteeism.data;
      }).catch((response) => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "No se pudo conectar al servicio: "+response;
            });
  },
  computed: {    
    ...mapState("modRequest",["absenteeism"]),
  },

  methods:{
    ...mapActions("modRequest", [
      "actGetAbsenteeism",
      "actSaveObsAbse",
    ]),

    saveObservation(){
      let data = [];
      data = {
        license_id: this.$route.params.id,
        sharp_id: this.$route.params.cc,
        observations: this.observaciones,
      }

      this.actSaveObsAbse(data).then(() =>{
                  this.success.flag = true;
                  this.success.class = "valid";
                  this.success.message = "El formato se guardó con exito, puede descargarlo";

                }).catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "Ocurrio un error al actualizar los datos: "+response;
                });      
    },

    formatDate(date) {
      var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

      if (month.length < 2) 
        month = '0' + month;
      if (day.length < 2) 
        day = '0' + day;
      return [year, month, day].join('-');
    },
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },
     hideModalAvailability(){
       this.$router.push({ path: '/solicitudes' });
     }
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-request {
  .title-3 {
        font-size: 24px;
        font-weight: bold;
        color: #1C3A4E;
      }
  .cont-request-text {    
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-request {         
      .button1 {
        background: #E9ECEE;
        color: #1C3A4E;
        //border-radius: 50px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;   
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#cddce6, 5);
        }
      } 
      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;  
        padding-left: 2%;
        padding-right: 2%;
        &:hover {
          background: darken(#7a7c7e, 5);
        }
      }
    }
  }
  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: left !important;  
  } 
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  } 
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .centerImg1 {
    width: 16px;
    height: 16px;
    //position: absolute;
    //left: 50%;
    top: 100%; 
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: right;
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

    /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: green;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px green;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
}
</style>